import { IdsAccordion } from '@ids/react';

import { Text } from '@mobi/ds';

const FaqStructured = ({ data }) => {
  return data.map((accordion, index) => {
    return (
      <IdsAccordion header={accordion.title} key={index}>
        {accordion.text.map((text, idx) => {
          return (
            <Text as="p" size="md" key={idx}>
              {text}
            </Text>
          );
        })}
      </IdsAccordion>
    );
  });
};

export default FaqStructured;
